/**
 * Utilitários para manipulação de CNPJs
 */

/**
 * Opções padrão pra validador/formatador de CNPJ do @brazilian-utils.
 * version: 2 aceita formato alfanumérico (NT RFB 49/2024) E numérico legado.
 */
export const CNPJ_OPTS = { version: 2 }

/**
 * Normaliza CNPJ removendo pontuação e forçando UPPERCASE.
 * Aceita CNPJ legado (somente dígitos) e alfanumérico (NT RFB 49/2024:
 * 12 primeiras posições podem ser A-Z ou 0-9; 2 últimos dígitos numéricos).
 * @param {string} cnpj - CNPJ para normalizar
 * @returns {string} CNPJ normalizado (A-Z e 0-9 apenas)
 */
export const normalizeCNPJ = (cnpj) => {
  if (!cnpj) return ''
  return cnpj.toString().toUpperCase().replace(/[^A-Z0-9]/g, '')
}

/**
 * Compara dois CNPJs normalizados
 * @param {string} cnpj1 - Primeiro CNPJ
 * @param {string} cnpj2 - Segundo CNPJ
 * @returns {boolean} True se os CNPJs são iguais
 */
export const compareCNPJs = (cnpj1, cnpj2) => {
  return normalizeCNPJ(cnpj1) === normalizeCNPJ(cnpj2)
}

/**
 * Verifica se um CNPJ está presente em uma lista de CNPJs
 * @param {string} cnpj - CNPJ para verificar
 * @param {Array} cnpjList - Lista de CNPJs
 * @returns {boolean} True se o CNPJ está presente na lista
 */
export const isCNPJPresent = (cnpj, cnpjList) => {
  const normalizedCnpj = normalizeCNPJ(cnpj)
  return cnpjList.some(listCnpj => normalizeCNPJ(listCnpj) === normalizedCnpj)
}

/**
 * Filtra uma lista de branches baseado em uma lista de CNPJs disponíveis
 * @param {Array} branches - Lista de branches
 * @param {Array} availableCNPJs - Lista de CNPJs disponíveis
 * @returns {Array} Lista de branches filtrada
 */
export const filterBranchesByCNPJs = (branches, availableCNPJs) => {
  return branches.filter(branch => 
    isCNPJPresent(branch.Document, availableCNPJs)
  )
} 